import { render, staticRenderFns } from "./wxFileView.vue?vue&type=template&id=290fcc3c&scoped=true"
import script from "./wxFileView.vue?vue&type=script&lang=js"
export * from "./wxFileView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290fcc3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('290fcc3c')) {
      api.createRecord('290fcc3c', component.options)
    } else {
      api.reload('290fcc3c', component.options)
    }
    module.hot.accept("./wxFileView.vue?vue&type=template&id=290fcc3c&scoped=true", function () {
      api.rerender('290fcc3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/task/wxFileView.vue"
export default component.exports